<template>
    <app-layout>
        <template #header>
        </template>

        <div class="py-2">
            <div>
                <div class="bg-white p-3">

                                <h3>{{ product.name }}</h3>
            <flash-messages />
                    <div class="product-view p-8 -mr-6 -mb-8 flex flex-wrap">
                        <div class="row">
                            <div class="col-sm-1">
                                <ul class="image-list">
                                    <li v-for="image in this.images" @click="showImage(image)">
                                        <img v-bind:src="image.thumbnail"/>
                                    </li>
                                </ul>
                            </div>
                            <div class="col-sm-4">
          
                                <img v-bind:src="this.current_image" class="col-sm-12"/>
                            </div>                    
                            <div class="col-sm-3">
                            {{ product.short_description }}
                        </div>

                        <div class="add-to-cart col-sm-4">
                            <div class="card p-3">
                            <h3>{{ formatDollars(product.price) }}</h3>

                            <div v-if="product.inventory > 0">
                                <strong>Available on Truck: {{ product.inventory }}</strong>
                                <div v-if="product.user_id">
                                    Maximum order: {{ product.inventory }}
                                </div>
                            </div>
                            <div class="form-group row">
                                <label for="qty" class="col-sm-4 col-form-label">Qty</label>
                                <div class="col-sm-6">
                                    <input type="text" id="qty" class="form-control" v-model="formCart.qty"/>
                                </div>
                            </div>


                            <button type="button" class="btn btn-success" @click="this.add()">Add to Cart</button>
                            </div>
                        </div>
                    </div>
                    <div class="row mt-3">
                    <div class="col-sm-9" v-html="product.long_description">

                        </div>

                        <div class="col-sm-9" >
                          <WarrantyInformation v-if="warranty" :warranty="warranty" />
                        </div>

                    </div>
                </div>
                </div>
            </div>
        </div>
    </app-layout>
</template>

<script>
    import AppLayout from '@/Layouts/AppLayout'
    import FlashMessages from '@/Shared/FlashMessages'
    import WarrantyInformation from '@/Components/Products/WarrantyInformation.vue'

    export default {
        components: {
            AppLayout,
            FlashMessages,
            WarrantyInformation,
        },
      props: {
        product: Object,
        warranty: Object,
        images: Object,
        user: Object,
      },
  data() {
    return {
      formCart: this.$inertia.form({
        qty: 1,
        product_id: this.product.id
      }),
      current_image: this.product.image_url
    }
  },
  methods: {
    add() {
        if (this.product.user_id && 
            this.formCart.qty > this.product.inventory) {
            return;
        }
      this.formCart.post(this.route('cart.add', this.product.id), { 
          preserveScroll: true,
          onSuccess: () => { 
            this.$emit('updateCartItems')
            this.trackAddToCart(
              this.product,
              this.formCart.qty,
              this.$page.props
            );
          }
        })
    },
    showImage(image) {
        this.current_image = image.src;
    },
  },
    }
</script>

<style>

    .gallery-thumbnail img {
        width: 120px;
    }

    .image-list {
        list-style: none;
        margin: 0;
        padding: 0;
    }

    .image-list li {
        display: inline-block;
        max-width: 90px;
        margin: 0;
        padding: 0;
        border: #999999 1px solid;
    }
    .image-list li img {
        width: 100%;
        height: auto;
    }

</style>
